export const WAITING_OPPONENTS_MOCK = {
  status: 200,
  body: {
    status: 200,
    msg: 'OK',
    data: {
      waitingOpponents: {
        bet1: Math.random() < 0.5,
        bet25: Math.random() < 0.5,
        bet50: Math.random() < 0.5,
        bet100: Math.random() < 0.5,
        bet250: Math.random() < 0.5,
        bet500: Math.random() < 0.5,
        bet1000: Math.random() < 0.5,
        bet2500: Math.random() < 0.5,
        bet10000: Math.random() < 0.5,
      },
    },
  },
};
